import { API_URL, buildHeaders, handleResponse } from './apiClient';

export const getAllUsers = async (token) => {
  const response = await fetch(`${API_URL}/users`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Failed to fetch users');
};

export const getUserById = async (userId, token) => {
  const response = await fetch(`${API_URL}/users/${userId}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Failed to fetch user');
};

export const changeUserPassword = async (userId, newPassword, token) => {
  const response = await fetch(`${API_URL}/users/${userId}/password`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify({ newPassword }),
  });
  return handleResponse(response, 'Failed to change password');
};

export const toggleUserAdminStatus = async (userId, isAdmin, token) => {
  const response = await fetch(`${API_URL}/users/${userId}/admin`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify({ isAdmin }),
  });
  return handleResponse(response, 'Failed to update admin status');
};

export const deleteUser = async (userId, token) => {
  const response = await fetch(`${API_URL}/users/${userId}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Failed to delete user');
};

export const forcePasswordChangeAll = async (token) => {
  const response = await fetch(`${API_URL}/users/force-password-change`, {
    method: 'POST',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Failed to force password change');
};

export const forcePasswordChangeUser = async (userId, token) => {
  const response = await fetch(`${API_URL}/users/${userId}/force-password-change`, {
    method: 'POST',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Failed to force password change for user');
};

export const toggleUserActiveStatus = async (userId, isActive, token) => {
  const response = await fetch(`${API_URL}/users/${userId}/active`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify({ isActive }),
  });
  return handleResponse(response, 'Failed to toggle user active status');
};

export const updateUserEmail = async (userId, email, token) => {
  const response = await fetch(`${API_URL}/users/${userId}/email`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify({ email }),
  });
  return handleResponse(response, 'Failed to update user email');
};
